// based on rc-progress 2.2.7
import Progress, { Line, Circle } from './src/';

export { Line, Circle };

export default Progress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-progress/index.js
// module id = 815
// module chunks = 0